var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "timeline-heatmap",
      attrs: { "data-testid": "timeline-heatmap" },
    },
    [
      _c("div", { staticClass: "timeline-heatmap__container" }, [
        _c(
          "div",
          { staticClass: "timeline-heatmap__labels" },
          [
            _c("div", { staticClass: "timeline-heatmap__header-spacer" }),
            _vm._v(" "),
            _vm._l(_vm.sensors, function (sensor) {
              return _c(
                "div",
                {
                  key: sensor.id,
                  staticClass: "timeline-heatmap__sensor-name",
                  attrs: { title: sensor.name, "data-testid": "sensor-name" },
                },
                [_vm._v("\n        " + _vm._s(sensor.name) + "\n      ")]
              )
            }),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "timeline-heatmap__grid-wrapper" },
          [
            _c(
              "div",
              { staticClass: "timeline-heatmap__time-row" },
              _vm._l(_vm.timeSlots, function (slot) {
                return _c(
                  "div",
                  {
                    key: slot.index,
                    class:
                      slot.index % _vm.slotsPerHour === 0
                        ? "timeline-heatmap__time-label"
                        : "timeline-heatmap__time-label-hidden",
                    style: {
                      width:
                        slot.index % _vm.slotsPerHour === 0
                          ? _vm.cellWidth * _vm.slotsPerHour + "px"
                          : undefined,
                    },
                    attrs: { "data-testid": "time-slot-label" },
                  },
                  [
                    slot.index % _vm.slotsPerHour === 0
                      ? [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.formatHourLabel(slot.startMinute)) +
                              "\n          "
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                )
              }),
              0
            ),
            _vm._v(" "),
            _vm._l(_vm.sensors, function (sensor) {
              return _c(
                "div",
                {
                  key: sensor.id,
                  staticClass: "timeline-heatmap__row",
                  attrs: { "data-testid": "sensor-row" },
                },
                _vm._l(_vm.timeSlots, function (slot) {
                  return _c("div", {
                    key: sensor.id + "-" + slot.index,
                    staticClass: "timeline-heatmap__cell",
                    class: [
                      _vm.cellClass(sensor.id, slot.index),
                      {
                        "cell--hour-boundary":
                          slot.index % _vm.slotsPerHour === 0,
                      },
                      { "cell--clickable": _vm.clickable },
                    ],
                    style: { width: _vm.cellWidth + "px" },
                    attrs: {
                      "data-testid": "cell-" + sensor.id + "-" + slot.index,
                    },
                    on: {
                      mouseenter: function ($event) {
                        return _vm.onCellEnter(sensor.id, slot.index, $event)
                      },
                      mouseleave: _vm.onCellLeave,
                    },
                  })
                }),
                0
              )
            }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _vm.showLegend
        ? _c(
            "div",
            {
              staticClass: "timeline-heatmap__legend",
              attrs: { "data-testid": "heatmap-legend" },
            },
            [
              _c("span", [_vm._v(_vm._s(_vm.$t("legend.less")))]),
              _vm._v(" "),
              _c("div", {
                staticClass: "timeline-heatmap__cell cell--level-0 legend-cell",
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "timeline-heatmap__cell cell--level-1 legend-cell",
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "timeline-heatmap__cell cell--level-2 legend-cell",
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "timeline-heatmap__cell cell--level-3 legend-cell",
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "timeline-heatmap__cell cell--level-4 legend-cell",
              }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("legend.more")))]),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }